// BE invalid_fields key → TeamFinder filter form field. Used to translate an
// API field error into the form's inline error map and to look up titles for
// the summary toast.
export const TEAM_FINDER_BE_TO_FORM_FIELD: Record<string, string> = {
  gender_id: 'genderId',
  sport_id: 'sportId',
  generic_sport_id: 'sportId',
  player_type_id: 'positionIds',
  province_id: 'province',
  organization: 'organization',
}

// BE invalid_fields key → human title for the summary toast.
export const TEAM_FINDER_BE_TO_FIELD_TITLE: Record<string, string> = {
  gender_id: 'Gender',
  sport_id: 'Sport',
  generic_sport_id: 'Sport',
  player_type_id: 'Position',
  province_id: 'Province/State',
  organization: 'Organization',
}
